import React from 'react';
import { Route, Switch, Link } from "react-router-dom";
import Main from '../router/Main';
import SubPage from './SubPage';

import "../sass/common/common.scss"

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/">
          <Main></Main>
        </Route>

        <Route  path="/detail/:nation">
          <SubPage></SubPage>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
